import React from 'react';
import { CalendarPlus, ExternalLink, Navigation } from 'lucide-react';
import { directionsUrl, downloadIcs, googleCalendarUrl } from '../lib/calendarLinks';

const actionClass = 'inline-flex items-center justify-center gap-1.5 border px-3 py-3 sm:py-2 min-h-[44px] sm:min-h-0 font-heading uppercase tracking-widest text-[10px] transition-colors';

export const GameActions = ({ item }) => (
  <div className="grid grid-cols-2 sm:flex sm:flex-wrap gap-2 sm:col-span-2 pt-1 [&>*:last-child]:col-span-2 sm:[&>*:last-child]:col-span-1" data-testid={`game-actions-${item.id}`}>
    <button type="button" onClick={() => downloadIcs(item)} data-testid={`game-add-to-calendar-${item.id}`} className={`${actionClass} border-[#0a1f44] bg-[#0a1f44] text-white hover:bg-[#c8102e] hover:border-[#c8102e]`}>
      <CalendarPlus className="w-3.5 h-3.5" /> Add to Calendar
    </button>
    <a href={googleCalendarUrl(item)} target="_blank" rel="noopener noreferrer" data-testid={`game-google-calendar-${item.id}`} className={`${actionClass} border-[#0a1f44] text-[#0a1f44] hover:bg-[#0a1f44] hover:text-white`}>
      <ExternalLink className="w-3.5 h-3.5" /> Google Calendar
    </a>
    <a href={directionsUrl(item.location)} target="_blank" rel="noopener noreferrer" data-testid={`game-directions-${item.id}`} className={`${actionClass} border-[#c8102e] text-[#c8102e] hover:bg-[#c8102e] hover:text-white`}>
      <Navigation className="w-3.5 h-3.5" /> Directions
    </a>
  </div>
);
